module.exports = __webpack_public_path__ + "static/media/covid-19-news.8f41a733.jpg";